// src/App.js
import { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import Home from './pages/Home';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import SignUp from './pages/SignUp';
import Login from './pages/Login';
import Challenges from './pages/Challenges';
import ChallengeDetail from './pages/ChallengeDetail';
import Settings from './pages/Settings';
import Premium from './pages/Premium';
import GradientGenerator from './pages/GradientGenerator';
import Profit from './pages/Profit';
import Modal from "react-modal";

Modal.setAppElement("#root"); // Đảm bảo modal có thể hoạt động tốt với accessibility

function App() {

  return (
    <div className='bg-[#efefef] text-[#333c4d] min-h-screen p-4'>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/term-of-service" element={<TermsOfService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/login" element={<Login />} />
          <Route path="/app" element={<Challenges />} />
          <Route path="/app/challenge/:id" element={<ChallengeDetail />} />

          <Route path="/app/settings" element={<Settings />} />
          <Route path="/app/premium" element={<Premium />} />
          <Route path="/gen" element={<GradientGenerator />} />
          <Route path="/profit" element={<Profit />} />
        </Routes>
      </Router>
    </div>

  );
}

export default App;